"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var checkpoint_1 = require("./checkpoint");
var event_1 = require("./event");
var utils_1 = require("./utils");
var ScreenViewed = /** @class */ (function (_super) {
    __extends(ScreenViewed, _super);
    function ScreenViewed() {
        return _super.call(this, "screenViewed", {
            viewed: "",
            viewed_before: utils_1.default.getLocalStorage(utils_1.default.VIEWED_BEFORE_KEY) ? utils_1.default.getLocalStorage(utils_1.default.VIEWED_BEFORE_KEY) : "",
            screen_before_milliseconds: checkpoint_1.default.EndViewedScreen() ? checkpoint_1.default.EndViewedScreen() : ""
        }) || this;
    }
    ScreenViewed.prototype.GetViewed = function () {
        return this.getEventBody().getJson().viewed;
    };
    ;
    ScreenViewed.prototype.GetViewedBefore = function () {
        return this.getEventBody().getJson().viewed_before;
    };
    ;
    ScreenViewed.prototype.SetViewed = function (viewed, expires) {
        this.getEventBody().getJson().viewed = viewed;
        utils_1.default.setLocalStorage(utils_1.default.VIEWED_BEFORE_KEY, viewed, expires);
        return this;
    };
    ;
    ScreenViewed.prototype._isPrefab = function () {
        return true;
    };
    return ScreenViewed;
}(event_1.default));
exports.default = ScreenViewed;
//# sourceMappingURL=screenViewed.js.map